



















































































































import { toRefs, ref, reactive, defineComponent } from "@vue/composition-api";
import { useMainStore } from "@/store/storage";
import { db } from "../firebase/firebase";
import { Area } from "@/interfaces/interfaces";

export default defineComponent({
  props: {},
  setup(props, { root }) {
    const main = useMainStore();
    const areaform = ref(null);
    const state = reactive({
      id: "",
      area: "",
      page: root.$route.params.page,
      valid: false,
      showform: true,
      showmessage: false,
      showProgress: false,
      message: "",
      messageClass: "success",
      inspectionAreas: []
    });

    // db.collection("InspectionAreas")
    //   .orderBy("area", "asc")
    //   .onSnapshot((snapshot) => {
    //     // eslint-disable-next-line
    //     const areaList: any = [];
    //     snapshot.forEach((item) => {
    //       const obj = { id: item.id, ...item.data() };
    //       areaList.push(obj);
    //       // console.log(obj);
    //     });
    //     main.state.inspectionAreas = areaList;
    //   });

    function resetForm(): void {
      //@ts-ignore
      areaform.value.reset();
      //@ts-ignore
      areaform.value.resetValidation();
    }

    function editItem(item: Area): void {
      state.id = item.id as string;
      state.area = item.area;
      state.showform = true;

      root.$vuetify.goTo("#comeHere");
    }

    function deleteItem(item: Area): void {
      if (confirm("Are you sure you want to delete this?")) {
        db.collection("InspectionAreas")
          .doc(item.id)
          .delete()
          .then(() => {
            resetForm();
            console.log("ITEM DELETED");
          });
      }
    }

    // console.log("MAIN", main.state.inspectionAreas);

    function hideMessage() {
      setTimeout(() => {
        state.showmessage = false;
        state.showProgress = false;
      }, 3000);
    }

    function saveArea() {
      if (state.valid) {
        const order = new Date().valueOf();
        const data = {
          order,
          area: state.area
        };
        if (state.area) {
          state.valid = false;
          state.showProgress = true;

          if (!!state.id as boolean) {
            db.collection("InspectionAreas")
              .doc(state.id)
              .update(data)
              .then(() => {
                console.log("Data Updated");
                state.showmessage = true;
                state.showProgress = false;
                state.message = "Area updated successfully saved";
                state.messageClass = "success";
                resetForm();

                hideMessage();
              })
              .catch();
          } else {
            db.collection("InspectionAreas")
              .add(data)
              .then(() => {
                // console.log(state.page, state.area, order);
                state.showmessage = true;
                state.showProgress = false;
                state.message = "Area name successfully saved";
                state.messageClass = "success";
                //@ts-ignore
                areaform.value.reset();
                //@ts-ignore
                areaform.value.resetValidation();

                hideMessage();
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else {
          // alert("Provide Area");
          state.showmessage = true;
          state.showProgress = false;
          state.message = "Something was wrong with the Area name";
          state.messageClass = "error";
          hideMessage();
        }
      }
    }
    return {
      saveArea,
      areaform,
      editItem,
      resetForm,
      deleteItem,
      main: main.state,
      ...toRefs(state)
    };
  }
});
